import React, { useEffect, useContext } from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import auth from "../auth/auth";
import TopNavBar from "../components/provider/navigation/topNavbar";
import { ValidateLocalStorageToken } from "../constants/provider/constant";
import UserFeaturesContext from "../hook/UserDetails/UserFeaturesContext";
import { checkFeatureFeasbility } from "../helper/utils";
import { getFeaturesForUser } from "../components/SPOC/Helper/utils";
import { UnauthorizedRBAC } from "../components/SPOC/UnauthorizedRBAC";
import { BackdropLoader } from "../components/DoctorMangement/BackdropLoader";


export const ProtectedRouteProvider = ({ component: Component, featureName, ...rest}) => {
  const history = useHistory();
  const [searchDetails, setSearchDetails] = React.useState(null);
  const [searchAPIDetails, setSearchAPIDetails] = React.useState(null);
  const [selectedProviders, setSelectedProviders] = React.useState([]);
  const [resetFilters, setResetFilters] = React.useState(null);
  const [fetchData, setFetchData] = React.useState(false);
  const [navigateToAll, setNavigateToAll] = React.useState(false);
  const [isLoadingUserFeature, setIsLoadingUserFeature] = React.useState(false);
  const { userFeatures, saveUserFeatures } = useContext(UserFeaturesContext);


  useEffect(() => {
    const saveUserFeaturesInContextHook = async () => {
      if (userFeatures) return;
      setIsLoadingUserFeature(true);
      const {userFeature, userRoles} = await getFeaturesForUser(history)
      saveUserFeatures(userFeature, userRoles);
      setIsLoadingUserFeature(false);
    }
    saveUserFeaturesInContextHook();
  }, []);

  function resetFilter(){
    setSearchDetails(null);
    setSearchAPIDetails(null);
    setResetFilters(!resetFilters)
  }

  function searchById(value) {
    setSearchDetails(value);
    console.log("value",value)
  }

  function searchAPIDetailsFnc(value) {
    setSearchAPIDetails(value);
    console.log("value",value)
  }
  
  const providersUpdated = (value)=>{
    setSelectedProviders(value)
  }

if(!localStorage.getItem("access_token")){
  history.push('/login')
  return null
}
else
  return (
    <div className="py-16">
      <div>
        <TopNavBar {...rest} resetFilters={resetFilters} onSearchById={searchById} onSearchedDetails={searchAPIDetailsFnc} onProvidersChanged={providersUpdated} fetchData={fetchData} setFetchData={setFetchData}></TopNavBar>
      </div>
      <div>
        {isLoadingUserFeature ? <BackdropLoader isLoading={isLoadingUserFeature} /> :
          <Route
            {...rest}
            render={props => {
              if (auth.isAuthenticated() && ValidateLocalStorageToken(localStorage.getItem('user_details')) && [5432, 5433].includes(ValidateLocalStorageToken(localStorage.getItem("user_details"))?.roleId)) {
                return (
                  <>
                    {
                      checkFeatureFeasbility(featureName, userFeatures) ? (
                        <Component
                          {...props}
                          resetFilter={resetFilter}
                          searchAppointment={searchDetails}
                          searchAPIValues={searchAPIDetails}
                          selectedProviders={selectedProviders}
                          fetchData={fetchData}
                          setFetchData={setFetchData}
                          navigateToAll={navigateToAll}
                          setNavigateToAll={setNavigateToAll}
                        />
                      ) : (
                        <UnauthorizedRBAC />
                      )
                    }
                  </>
                )
              } else {
                return (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: {
                        from: props.location
                      }
                    }}
                  />
                );
              }
            }}
          />
        }
      </div>
    </div>
  );
};
